const { document } = require('window');
const $ = require('rgs-jquery');
require('rgs-velocity-animate');

const dataApi = {
	'slow-animate-scroll': function (){
		const target = $(this).attr('data-slow-scroll');
		if (target){
			$(target).velocity("scroll", { duration: 2000 });
		}
	},
};

$(document).on('click.anchor.data-api', '[data-slow-scroll]', dataApi['slow-animate-scroll']);
